import React, { createContext, useState, useContext } from 'react';

const DogListContext = createContext();

export const useDogList = () => useContext(DogListContext);

export const DogListProvider = ({ children }) => {
  const [daysList, setDaysList] = useState({});
  const [completedDogs, setCompletedDogs] = useState({});
  const [urgentDogs, setUrgentDogs] = useState({});

  return (
    <DogListContext.Provider value={{ daysList, setDaysList, completedDogs, setCompletedDogs, urgentDogs, setUrgentDogs }}>
      {children}
    </DogListContext.Provider>
  );
};